export default "__VITE_ASSET__DSy$E7Hr__"